import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import usePermissions from '../../hooks/usePermissions';

/**
 * checks if user is logged in and if they have required permissions and groups before navigating to a page
 * if not logged in, navigates to login page
 * if missing required groups and permissions, navigates to 'unauthorized' page
 *  
 */
export const ProtectedRoute = ({ requiredPermission, requiredGroups, children }) => {
    //get functions from hooks/context
    const { checkIsAuthenticated } = useUser()
    const { hasPermission, isInGroup } = usePermissions()
    const navigate = useNavigate()
    
    //check if user logged in and set isAuthorized state
    const isAuthenticated = checkIsAuthenticated()
    const [isAuthorized, setIsAuthorized] = useState(null)

    //before component mounts, check if user is logged in, and if they have the permissions/groups required to see the page
    useEffect(() => {
        if (!isAuthenticated) {
            setIsAuthorized(false)
            navigate("/login", { replace: true })
        } else if (requiredPermission && !hasPermission(requiredPermission.resource, requiredPermission.action)) {
            setIsAuthorized(false)
            navigate("/unauthorized", { replace: true })
        } else if (requiredGroups && !isInGroup(requiredGroups)) {
            setIsAuthorized(false)
            navigate("/unauthorized", { replace: true })
        } else {
            setIsAuthorized(true)
        }
    }, [isAuthenticated, requiredPermission, requiredGroups, hasPermission, isInGroup, navigate])


    return isAuthorized ? (children ? children : <Outlet />) : null
}
